import Vue from "vue";
import results from "./results_component";

if(document.getElementById('results')) {
    new Vue({
        el: "#results",
        components: {
            "results" : results
        }
    })
}